import { useParams, Link } from "react-router-dom";

import {
  FaLayerGroup,
  FaQuestionCircle,
  FaChartBar,
  FaCheckCircle,
  FaExclamationTriangle,
} from "react-icons/fa";

import {
  useGetBlueprintStatisticsQuery,
  
} from "../../slices/quizApiSlice";

const QuizBlueprintStatisticsScreen = () => {
  const { id } = useParams();
console.log("Quiz ID from params:", id);
  const {
  data: blueprintStats,
  isLoading,
} = useGetBlueprintStatisticsQuery(id, {
  skip: !id,
});

  

  if (isLoading) {
    return (
      <div className="p-10 text-center">Loading blueprint statistics...</div>
    );
  }

  const sections = blueprintStats?.sections || [];

  const totalQuestions = blueprintStats?.summary?.totalRequired || 0;

const totalMarks =
  blueprintStats?.summary?.totalMarks || 0;

  const difficultyStats = sections.reduce((acc, item) => {
    const level = item.difficulty || "medium";

    acc[level] = (acc[level] || 0) + Number(item.required || 0);

    return acc;
  }, {});

  return (
    <div
      className="
        min-h-screen
        bg-gradient-to-br
        from-slate-100
        via-blue-50
        to-indigo-100
        p-6
      "
    >
      <div className="max-w-6xl mx-auto">
        <Link
          to={`/quizzes/${id}`}
          className="
            inline-block
            mb-6
            rounded-xl
            bg-white
            px-5
            py-3
            text-blue-600
            shadow
          "
        >
          ← Back to Quiz
        </Link>

        <div
          className="
            rounded-3xl
            bg-white/80
            backdrop-blur
            shadow-2xl
            p-8
          "
        >
          <h1
            className="
              text-3xl
              font-bold
              text-gray-800
              mb-8
            "
          >
            Blueprint Statistics
          </h1>

          {/* Summary Cards */}

          <div
            className="
              grid
              md:grid-cols-4
              gap-5
            "
          >
            <StatCard
  icon={<FaLayerGroup />}
  title="Sections"
  value={sections.length}
  color="blue"
/>

<StatCard
  icon={<FaQuestionCircle />}
  title="Questions"
  value={totalQuestions}
  color="green"
/>

<StatCard
  icon={<FaChartBar />}
  title="Total Marks"
  value={totalMarks}
  color="purple"
/>

<StatCard
  icon={
    blueprintStats?.summary?.canGenerate ? (
      <FaCheckCircle />
    ) : (
      <FaExclamationTriangle />
    )
  }
  title="Availability"
  value={
    blueprintStats?.summary?.canGenerate
      ? "Ready"
      : "Insufficient"
  }
  color={
    blueprintStats?.summary?.canGenerate
      ? "green"
      : "red"
  }
/>
          </div>

          {/* Difficulty Distribution */}

          <div
            className="
              mt-10
              rounded-xl
              border
              bg-gray-50
              p-6
            "
          >
            <h2
              className="
                text-xl
                font-bold
                mb-5
              "
            >
              Difficulty Distribution
            </h2>

            <div
              className="
                grid
                md:grid-cols-3
                gap-4
              "
            >
              {["easy", "medium", "hard"].map((level) => (
                <div
                  key={level}
                  className="
                      rounded-xl
                      bg-white
                      border
                      p-5
                    "
                >
                  <p
                    className="
                        uppercase
                        text-sm
                        text-gray-500
                        font-semibold
                      "
                  >
                    {level}
                  </p>

                  <p
                    className="
                        mt-3
                        text-3xl
                        font-bold
                      "
                  >
                    {difficultyStats[level] || 0}
                  </p>

                  <p className="text-gray-500">Questions</p>
                </div>
              ))}
            </div>
          </div>

          {/* Section Details */}

          <div className="mt-10">
            <h2
              className="
                text-xl
                font-bold
                mb-5
              "
            >
              Blueprint Sections
            </h2>

            <div className="space-y-4">
              {sections.map((section, index) => (
                <div
                  key={index}
                  className="
                        rounded-xl
                        border
                        bg-gray-50
                        p-5
                        flex
                        justify-between
                        items-center
                      "
                >
                  <div>
                    <h3
                      className="
                            font-bold
                          "
                    >
                      Section {index + 1}
                    </h3>

                    <p className="text-gray-600">
                      {section.chapter?.name || "No chapter"}

                      {" • "}

                      {section.name || "No section name"}
                    </p>
                  </div>

                  <div
                    className="
                          text-right
                        "
                  >
                    <p className="font-bold">{section.required} Questions</p>

                    <p className="text-gray-600">
                      {section.marksPerQuestion} Marks Each
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const StatCard = ({ icon, title, value, color }) => {
  const colors = {
    blue: "bg-blue-50 text-blue-600",

    green: "bg-green-50 text-green-600",

    purple: "bg-purple-50 text-purple-600",

    red: "bg-red-50 text-red-600",
  };

  return (
    <div
      className={`
        rounded-xl
        p-5
        ${colors[color]}
      `}
    >
      <div className="text-2xl">{icon}</div>

      <p
        className="
          mt-3
          text-sm
          font-semibold
          uppercase
        "
      >
        {title}
      </p>

      <p
        className="
          text-3xl
          font-bold
          mt-2
        "
      >
        {value}
      </p>
    </div>
  );
};

export default QuizBlueprintStatisticsScreen;
